import { render, staticRenderFns } from "./ThirdPage.vue?vue&type=template&id=739b94bf&scoped=true&"
import script from "./ThirdPage.vue?vue&type=script&lang=js&"
export * from "./ThirdPage.vue?vue&type=script&lang=js&"
import style0 from "./ThirdPage.vue?vue&type=style&index=0&id=739b94bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739b94bf",
  null
  
)

export default component.exports